// extracted by mini-css-extract-plugin
module.exports = {"legendWrapper":"Legend_legendWrapper__3i0fC","legendItem":"Legend_legendItem__GVn4d"};